import { Goal, ID } from '@griply/types';

import { sortItems } from '../sort-items';

export const sortGoalsHierarchically = (goals: Goal[], customOrder: ID[]) => {
  if (!goals.length) {
    return [];
  }

  // A goal is a "root" in this context if its parent is NOT in the list.
  const goalIds = new Set(goals.map((goal) => goal.id));
  const roots: Goal[] = [];
  const childrenMap = new Map<ID, Goal[]>();

  goals.forEach((goal) => {
    const parentId = goal.parentIds?.[goal.parentIds.length - 1];
    const parentExists = parentId && goalIds.has(parentId);

    if (!parentExists) {
      roots.push(goal);
      return;
    }

    const existing = childrenMap.get(parentId!) ?? [];
    existing.push(goal);
    childrenMap.set(parentId!, existing);
  });

  const sortedRoots = sortItems(roots, customOrder, 'id');

  // Flatten recursively, sorting children by customOrder at each level so the
  // order (including direction reversals applied to customOrder) propagates
  // uniformly through the tree.
  const buildList = (parents: Goal[]): Goal[] =>
    parents.flatMap((parent) => {
      const children = childrenMap.get(parent.id);
      if (children?.length) {
        const sortedChildren = sortItems(children, customOrder, 'id');
        return [parent, ...buildList(sortedChildren)];
      }
      return [parent];
    });

  return buildList(sortedRoots);
};
